<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
      <base-material-dialog
        :title='item.data === undefined ? "月度排班" : "排班编辑" '
        :dialog="item.show"
        @on-dialog-change='dialogChange'
        persistent
        fullscreen
      >
        <template v-slot:content>
           <v-card class="px-5 py-5" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-row>
                <v-col cols="12" md='2' v-for="(item, idx) in form.list" :key="idx">
                  <v-card class="rounded-lg" min-height='180'>
                    <v-card-title class="pb-0">
                      <v-chip dark label small :color="item.weekValue === 0 ||  item.weekValue === 6? 'red' : 'green'">{{item.weekDesc}}</v-chip>
                      <v-spacer></v-spacer>
                      <span class="size-12">{{item.day}}</span>
                    </v-card-title>
                    <v-card-text class="pt-1">
                       <v-switch
                          v-model="form.list[idx].work"
                          inset
                          :false-value="2"
                          :true-value="1"
                          :label="form.list[idx].work === 1 ? '上班' : '休息'"
                          @change="workChange(form.list[idx])"
                        ></v-switch>
                        <v-switch
                          v-model="form.list[idx].legal"
                          inset
                          dense
                          :disabled="form.list[idx].work === 1"
                          :false-value="0"
                          :true-value="1"
                          :label="form.list[idx].legal === 1 ? '法定假日(请假不参与薪资扣除计算)' : '非法定假日'"
                        >
                        </v-switch>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/office/worksetting.js'
  import { getMonthDay } from '@/utils/tool.js'

  export default {
    name: 'WorkSetEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        switch1: false,
        loading: false,
        monthDays: [],
        required: [
          value => !!value || '此项为必填项!'
        ],
        form: {
          list: []
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.loading = true
          save(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      workChange (item) {
        item.legal = 0
      },
      fmMonthDays () {
        this.form.list = []
        getMonthDay().forEach(item => {
          this.form.list.push({
            work: item.weekValue === 0 || item.weekValue === 6 ? 2 : 1,
            legal: 0,
            dayReport: item.weekValue === 0 || item.weekValue === 6 ? 0 : 1,
            weekReport: item.weekValue === 0 || item.weekValue === 6 ? 0 : 1,
            workTime: this.$moment(new Date(item.day)).unix(),
            day: item.day,
            weekValue: item.weekValue,
            weekDesc: item.weekDesc
          })
        });
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
          } else {
            this.fmMonthDays()
          }
        }
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined
      }
    }
  }
</script>

<style lang="sass" scoped>
</style>
